import { render, staticRenderFns } from "./createReport.vue?vue&type=template&id=3700dc73&"
import script from "./createReport.vue?vue&type=script&lang=js&"
export * from "./createReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports